import { IApplicationState, TBoardId } from '../../../types/types';
import { getBoardPermissionsAllowEdit } from './getBoardPermissionsAllowEdit';

export const isAllowShare = (state: IApplicationState, boardId: TBoardId): boolean => {
    return state.model.dashboards[boardId] && state.model.dashboards[boardId].permissions.authPermissions.allowShare
        && getBoardPermissionsAllowEdit(state, boardId);
};
